// The University of Alabama's undergraduate majors (#2652). Read on
// 2026-10-01 from the official 2026-2027 Undergraduate Catalog's Majors and
// Programs page (catalog.ua.edu/programs), which lists every program with
// its degree ("Accounting, BS") and links it under the college that offers
// it: every bachelor's line kept, minors, certificates, ROTC programs and
// the RN to BSN completion track (for licensed nurses, not first-year
// applicants) left out. Degree abbreviations are the catalog's own (BS, BA,
// BSE, BSChE, BCH, BSG, BAC, BM, BFA, BSN, BSW). The two Music Education
// BSE lines keep their certification in the name so they stay distinct.
// The Nursing flag paraphrases UA's Nursing Admissions page (the college
// file's `nursing` source). The KB's majors list was the starting point;
// the catalog wins.
const majors = {
    "slug": "university-of-alabama",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UA's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "J. Frank Barefield Jr. College of Arts and Sciences",
            "source": {
                "label": "UA Undergraduate Catalog, J. Frank Barefield Jr. College of Arts and Sciences",
                "url": "https://catalog.ua.edu/undergraduate/arts-sciences/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Liberal Arts and Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BCH"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Criminology & Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Foreign Languages and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BSG"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Marine Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Music Composition",
                    "degree": "BM"
                },
                {
                    "name": "Music Performance",
                    "degree": "BM"
                },
                {
                    "name": "Music Theory",
                    "degree": "BM"
                },
                {
                    "name": "Music Therapy",
                    "degree": "BM"
                },
                {
                    "name": "Music with a concentration in Arts Administration",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Musical Audio Technology",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Speech, Language, and Hearing Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "Culverhouse College of Business",
            "source": {
                "label": "UA Undergraduate Catalog, Culverhouse College of Business",
                "url": "https://catalog.ua.edu/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Business Cyber Security",
                    "degree": "BS"
                },
                {
                    "name": "Business Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "General Business",
                    "degree": "BS"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Operations Management",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Communication and Information Sciences",
            "source": {
                "label": "UA Undergraduate Catalog, College of Communication and Information Sciences",
                "url": "https://catalog.ua.edu/undergraduate/communication-information-sciences/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BAC"
                },
                {
                    "name": "Creative Media",
                    "degree": "BA"
                },
                {
                    "name": "Informatics",
                    "degree": "BS"
                },
                {
                    "name": "News Media",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UA Undergraduate Catalog, College of Education",
                "url": "https://catalog.ua.edu/undergraduate/education/"
            },
            "majors": [
                {
                    "name": "Collaborative Education Program",
                    "degree": "BSE"
                },
                {
                    "name": "Educational Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BSE"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Multiple Abilities Program",
                    "degree": "BSE"
                },
                {
                    "name": "Music Education (Certification in Instrumental Music)",
                    "degree": "BSE"
                },
                {
                    "name": "Music Education (Certification in Vocal/Choral Music)",
                    "degree": "BSE"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BSE"
                }
            ]
        },
        {
            "name": "Lee J. Styslinger Jr. College of Engineering",
            "source": {
                "label": "UA Undergraduate Catalog, Lee J. Styslinger Jr. College of Engineering",
                "url": "https://catalog.ua.edu/undergraduate/engineering/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSChE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Cyber Security",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Manufacturing Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Metallurgical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Human Environmental Sciences",
            "source": {
                "label": "UA Undergraduate Catalog, College of Human Environmental Sciences",
                "url": "https://catalog.ua.edu/undergraduate/human-environmental-sciences/"
            },
            "majors": [
                {
                    "name": "Addiction and Recovery",
                    "degree": "BS"
                },
                {
                    "name": "Apparel and Textiles",
                    "degree": "BS"
                },
                {
                    "name": "Consumer Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BS"
                },
                {
                    "name": "Food and Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": "BS"
                },
                {
                    "name": "Human Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Interior Design",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Capstone College of Nursing",
            "source": {
                "label": "UA Undergraduate Catalog, Capstone College of Nursing",
                "url": "https://catalog.ua.edu/undergraduate/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN",
                    "flag": "First-time freshmen are now admitted to nursing at entry through a college review, which requires an ACT or SAT score; apply by December 4, 2026.",
                    "flagSource": "nursing"
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "UA Undergraduate Catalog, School of Social Work",
                "url": "https://catalog.ua.edu/undergraduate/social-work/"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        }
    ]
};

export default majors;
